const AboutUsIcon = '/icons/side-menu/about-us.svg';
const ContactUsIcon = '/icons/side-menu/contact-us.svg';
const ExperiencesIcon = '/icons/side-menu/experiences.svg';
const FoodMenuIcon = '/icons/side-menu/food-menu.svg';
const LocationOutlinedIcon = '/icons/side-menu/location-outlined.svg';
const NotificationIcon = '/icons/navbar/notification-icon.svg';
const NotificationRedDottedIcon = '/icons/navbar/notification-red-dotted-icon.svg';
const OffersIcon = '/icons/side-menu/offers.svg';
const PrivateBookingIcon = '/icons/side-menu/private-booking.svg';
const SearchIcon = '/icons/shared/search.svg';
const VouchersIcon = '/icons/side-menu/vouchers.svg';

interface MenuItem {
  title: string;
  img: string | File;
  path: string;
  isResponsive: boolean;
  isAuth: boolean;
  isLink: boolean;
  event?: () => void;
}
export const getPages = (
  isAllNotificationsAreRead,
  openNotificationsPopover
): MenuItem[] => [
  {
    title: 'notificationsCenter',
    img: isAllNotificationsAreRead() ? NotificationIcon : NotificationRedDottedIcon,
    path: 'fake-notification-link',
    isResponsive: true,
    isAuth: true,
    isLink: false,
    event: (): void => openNotificationsPopover(),
  },
  {
    title: 'movieFinder',
    img: SearchIcon,
    path: 'movie-finder',
    isResponsive: true,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'cinemas',
    img: LocationOutlinedIcon,
    path: 'cinemas',
    isResponsive: true,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'experiences',
    img: ExperiencesIcon,
    path: 'experiences',
    isResponsive: true,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'offers',
    img: OffersIcon,
    path: 'offers',
    isResponsive: true,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'privateBooking',
    img: PrivateBookingIcon,
    path: 'private-booking',
    isResponsive: false,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'foodMenu',
    img: FoodMenuIcon,
    path: 'food-menu',
    isResponsive: false,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'vouchers',
    img: VouchersIcon,
    path: 'voucher-redemption',
    isResponsive: false,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'contactUs',
    img: ContactUsIcon,
    path: 'contact-us',
    isResponsive: false,
    isAuth: false,
    isLink: true,
  },
  {
    title: 'aboutUs',
    img: AboutUsIcon,
    path: 'about-us',
    isResponsive: false,
    isAuth: false,
    isLink: true,
  },
];
